// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import styled from 'styled-components';
import FieldView from './FieldView';
import DollarOutput from './DollarOutput';

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const StyledPercentage = styled.div`
  margin-right: 30px;
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const AdditionalCharge = ({ amount, name, percent }) => (
  <FieldView name={name}>
    <StyledWrapper>
      <StyledPercentage>{`${percent}%`}</StyledPercentage>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      <DollarOutput value={amount.toFixed(2)} />
    </StyledWrapper>
  </FieldView>
);

export default AdditionalCharge;
